import { Theme } from '@rhg/libs/material';

export const styleMaskThemeBackground = (theme: Theme) =>
    theme.palette.mode === 'light' ? 'mask.white.60p' : 'mask.black.20p';

export const styleInfoColor = (theme: Theme) =>
    theme.palette.mode === 'light' ? 'info.main' : 'info.dark';

/**
 * Returns the given light-mode background token in light mode and the shared
 * `mask.black.20p` overlay in dark mode.
 */
export const bgByMode = (theme: Theme, lightToken: string) =>
    theme.palette.mode === 'light'
        ? lightToken
        : theme.palette.mask.black['20p'];

/**
 * Color/background tokens for a tab-style Chip, varying by selected state and
 * theme mode.
 */
export const styleTabColors = (isSelected: boolean) => ({
    color: isSelected ? 'primary.contrastText' : 'text.body',
    backgroundColor: ({ palette: { mode } }: Theme) => {
        if (isSelected) {
            return 'secondary.main';
        }

        return mode === 'light' ? 'primary.contrastText' : 'action.selected';
    },
});

/**
 * Full `sx` for a tab-style Chip, applying {@link styleTabColors} on both the
 * resting and hover states.
 */
export const styleTab = (isSelected: boolean) => ({
    ...styleTabColors(isSelected),
    '&:hover': styleTabColors(isSelected),
});
